import { ExecutionStepStatus } from "../../types/ExecutionStatus.ts";
import { ExecutionStepActionType } from "../../types/ExecutionStepActionType.ts";

const executionJobStepRowStyles = {
  stepStatusChipSxByStatus: {
    pending: { backgroundColor: "secondary.light", color: "secondary.contrastText" },
    running: { backgroundColor: "info.light", color: "info.contrastText" },
    completed: { backgroundColor: "warning.light", color: "warning.contrastText" },
    failed: { backgroundColor: "error.light", color: "error.contrastText" },
    skipped: { backgroundColor: "grey.400", color: "text.primary" },
  } satisfies Record<ExecutionStepStatus, Record<string, string>>,
  actionTypeChipSxByActionType: {
    createActivity: { backgroundColor: "primary.light", color: "primary.contrastText" },
    changeStatus: { backgroundColor: "secondary.light", color: "secondary.contrastText" },
    createInquiryToCustomer: { backgroundColor: "success.light", color: "success.contrastText" },
    sendCustomerMessage: { backgroundColor: "info.light", color: "info.contrastText" },
    sendEmail: { backgroundColor: "warning.light", color: "warning.contrastText" },
    sendBeaOrFax: { backgroundColor: "error.light", color: "error.contrastText" },
    createNote: { backgroundColor: "grey.200", color: "text.primary" },
    updateField: { backgroundColor: "grey.300", color: "text.primary" },
    updateCaseData: { backgroundColor: "grey.300", color: "text.primary" },
    createDocument: { backgroundColor: "primary.main", color: "primary.contrastText" },
    createBookingEntry: { backgroundColor: "secondary.main", color: "secondary.contrastText" },
    createWireTransfer: { backgroundColor: "info.main", color: "info.contrastText" },
  } satisfies Record<ExecutionStepActionType, Record<string, string>>,
};

export default executionJobStepRowStyles;
